import {
    GET_TYPE_DOCUMENTS_PROVIDER,
    GET_TYPE_DOCUMENTS_PROVIDER_SUCCESS,
    GET_TYPE_DOCUMENTS_PROVIDER_ERROR
} from "./actionTypes"


const initialState = {
    loading: false,
    error: false,
    message: '',
    docs: [],
    idDocument: 0,
    loading: true,
    refresh: false,
    name: '',
    required: '',
    has_validity: '',
    slug: '',
}

const Document = (state = initialState, action) => {

    switch (action.type) {

        case GET_TYPE_DOCUMENTS_PROVIDER:
            state = {
                ...state,
                loading: true,
                refresh: false,
            }
            break
        case GET_TYPE_DOCUMENTS_PROVIDER_SUCCESS:
            state = {
                ...state,
                docs: action.payload?.data,
                refresh: true,
                loading: false
            }
            break  
        case GET_TYPE_DOCUMENTS_PROVIDER_ERROR:
            state = { ...state, error: action.payload, loading: false }
            break
                 
        default:
            state = { ...state }
        break
    }

    return state
}
export default Document

